import React, { Component } from 'react';
import { AgGridReact } from 'ag-grid-react';

import 'ag-grid-community/dist/styles/ag-grid.css';
import 'ag-grid-community/dist/styles/ag-theme-alpine.css';

export class Result extends Component {
    getColumnDefs = () => {
        return [
            {
                headerName: 'Komponent',
                field: 'component',
                flex: 1,
            },
            {
                headerName: 'Avgift ' + this.props.oldYear,
                field: 'oldPrice',
                flex: 1,
                headerClass: 'right-align',
                cellStyle: { 'text-align': 'right' },
                valueFormatter: params => {
                    return params.value != null ? new Intl.NumberFormat('nb-NO', { maximumFractionDigits: 2, minimumFractionDigits: 2 }).format(params.value) : 'N/A';
                },
                hide: (this.props.vehicleCategory === 311 && this.props.oldYear < 2021)
            },
            {
                headerName: 'Avgift ' + this.props.newYear,
                field: 'newPrice',
                flex: 1,
                headerClass: 'right-align',
                cellStyle: { 'text-align': 'right' },
                valueFormatter: params => {
                    return params.value != null ? new Intl.NumberFormat('nb-NO', { maximumFractionDigits: 2, minimumFractionDigits: 2 }).format(params.value) : 'N/A';
                }
            },
            {
                headerName: 'Differanse',
                field: 'priceDiff',
                flex: 1,
                headerClass: 'right-align',
                cellStyle: { 'text-align': 'right' },
                valueFormatter: params => {
                    return params.value != null ? new Intl.NumberFormat('nb-NO', { maximumFractionDigits: 2, minimumFractionDigits: 2 }).format(params.value) : 'N/A';
                },
                hide: (this.props.vehicleCategory === 311 && this.props.oldYear < 2021)
            }
        ];
    }

    onGridReady = params => {
        this.gridApi = params.api;
        this.gridColumnApi = params.columnApi;
    };

    componentDidUpdate() {
        if (this.props.loading) {
            this.gridApi.showLoadingOverlay();
        }
        else if (this.props.error) {
            this.gridApi.showNoRowsOverlay();
        }
        else {
            this.gridApi.hideOverlay();
        }
    }

    render() {
        return (
            <div className="ag-theme-alpine no-scroll no-padding grid-wrapper">
                <AgGridReact
                    domLayout="autoHeight"
                    columnDefs={this.getColumnDefs()}
                    rowClassRules={{ 'bold': function (params) { return params.data.bold === true; } }}
                    rowData={this.props.rowData}
                    onGridReady={this.onGridReady}
                    overlayNoRowsTemplate={'<span class="ag-overlay-loading-center">En feil oppstod ved henting av beregnede avgifter</span>'} />
            </div>
        );
    }
}
